export interface LanguagePair {
  sourceLanguage: string;
  targetLanguages: string[];
}

export const LANGUAGE_MAP: Record<string, string[]> = {
  auto: ['en', 'zh', 'ja', 'ko', 'fr', 'de', 'ru', 'pt', 'es', 'ar', 'th', 'it', 'tr', 'vi', 'pl', 'he', 'id', 'hi', 'nl'],
  en: ['zh', 'ja', 'ko', 'fr', 'de', 'ru', 'pt', 'es', 'ar', 'th', 'it', 'tr', 'vi', 'pl', 'he', 'id', 'hi', 'nl'],
  zh: ['en', 'ja', 'ko', 'fr', 'de', 'ru', 'pt', 'es', 'ar', 'th', 'it', 'tr', 'vi', 'pl', 'he', 'id', 'hi', 'nl'],
  ja: ['zh', 'en'],
  ko: ['zh', 'en'],
  fr: ['zh', 'en'],
  de: ['zh', 'en'],
  ru: ['zh', 'en'],
  pt: ['zh', 'en'],
  es: ['zh', 'en'],
  ar: ['zh', 'en'],
  th: ['zh', 'en'],
  it: ['zh', 'en'],
  tr: ['zh', 'en'],
  vi: ['zh', 'en'],
  pl: ['zh', 'en'],
  he: ['zh', 'en'],
  id: ['zh', 'en'],
  hi: ['zh', 'en'],
  nl: ['zh', 'en'],
};

export class LanguageService {
  getDefaultTarget(srcLanguage: string): string {
    const targets = LANGUAGE_MAP[srcLanguage];
    return targets?.[0] ?? 'en';
  }

  getSupportedTargets(srcLanguage: string): string[] {
    return LANGUAGE_MAP[srcLanguage] ?? [];
  }

  isSupported(srcLanguage: string, tgtLanguage: string): boolean {
    const targets = LANGUAGE_MAP[srcLanguage];
    return targets?.includes(tgtLanguage) ?? false;
  }
}
